import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_right",
  "use": "arrow_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_right\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18.4141L16.4141 12L10 5.58594V8.41436L13.5857 12L10 15.5857V18.4141Z\" fill=\"#E0E0E0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol